import { createApp } from 'vue'
import PersonalFundraising from './PersonalFundraising'

const el = '.kb-component--personal-fundraising'

const mapImage = (img) => {
    return {
        id: img.Id,
        name: img.Name,
        url: img.Url
    }
}

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((PersonalFundraisingDOM) => {
            const pageId = PersonalFundraisingDOM.dataset.pageId
            if (pageId) Store.commit('main/set_page_id', pageId)

            const isMindegave =
                PersonalFundraisingDOM.hasAttribute('is-mindegave')
            const isUpdate = PersonalFundraisingDOM.hasAttribute('is-update')
            const personalFundraising = JSON.parse(
                PersonalFundraisingDOM.dataset.personalFundraising
            )
            const showUnsavedChangesWarning =
                PersonalFundraisingDOM.hasAttribute('show-unsaved-changes-warning')
            const showUserConsent = PersonalFundraisingDOM.hasAttribute('show-user-consent')
            const showPostalCodeInput = PersonalFundraisingDOM.hasAttribute('show-postalcode-input')
            const hideFundraisingTarget = PersonalFundraisingDOM.hasAttribute('hide-fundraising-target')
            const hideFundraisingEndDate = PersonalFundraisingDOM.hasAttribute('hide-fundraising-enddate')
            const showFundraiseCard = PersonalFundraisingDOM.hasAttribute('show-fundraise-card')

            if (personalFundraising?.Images)
                personalFundraising.personalStoryImages =
                    personalFundraising.Images.map((i) => mapImage(i))
            if (personalFundraising?.CoverImage)
                personalFundraising.fundraiseImage = mapImage(
                    personalFundraising.CoverImage
                )

            const userData = JSON.parse(PersonalFundraisingDOM.dataset.userData)
            const privacyPolicyEncoded = PersonalFundraisingDOM.dataset.privacyPolicyEncoded
            const component = createApp(PersonalFundraising, {
                isUpdate,
                isMindegave,
                personalFundraising,
                showUnsavedChangesWarning,
                userData,
                privacyPolicyEncoded,
                showUserConsent,
                showPostalCodeInput,
                hideFundraisingTarget,
                hideFundraisingEndDate,
                showFundraiseCard
            }).use(Store)
            component.mount(PersonalFundraisingDOM)
        })
    }
}
